import React from 'react';

import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import { Typo, Rhythm } from 'components/Layout';
import { Input, Button } from 'components/Form';
import { createStructuredSelector, createSelector } from 'reselect';
import { getMerchantProp } from 'modules/user/selectors/merchant';
import { getName, getEmail } from 'modules/user/selectors/user';

import styles from './styles.css';

const initialValues = createSelector(
  getMerchantProp('merchantName'),
  getName,
  getEmail,
  (url, name, email) => ({ url, email, name })
);

const mapStateToProps = createStructuredSelector({ initialValues });

export default compose<any, any>(
  connect(mapStateToProps),
  reduxForm({
    form: 'contactUs',
    onSubmit: (formData, _, { onSubmit }) => onSubmit(formData),
    validate: ({ email, phone }) => {
      const errors = {};
      if (!email) errors.email = 'Please enter email address';
      if (!phone) errors.phone = 'Please enter your phone number';
      return errors;
    },
  })
)(({ handleSubmit, pristine, invalid, submitting }: any) => (
  <div className={styles.root}>
    <div className={styles.header}>
      <Typo.Title>Get started with Enterprise!</Typo.Title>
      <Typo.Paragraph>
        Just leave us your details and we’ll get in touch asap.
      </Typo.Paragraph>
    </div>
    <Rhythm vertical>
      <Input name="name" placeholder="" label="Name" disabled />
      <Input name="email" placeholder="" label="Email address" />
      <Input name="phone" label="Phone number (include country code)" />
      <Input name="url" label="Store URL" disabled />
      <Rhythm center>
        <Button
          onClick={handleSubmit}
          disabled={invalid || pristine}
          isLoading={submitting}
        >
          Let's connect!
        </Button>
      </Rhythm>
    </Rhythm>
  </div>
));
